<script lang="ts">
	//Design system components
	import { Input, Text, Button } from '@Shelly/shelly-design-system';
	//Stores
	import { home_data } from 'src/stores/account/user';
	//Services
	import { format } from 'svelte-i18n';
	//Components
	import { onMount } from 'svelte';
	import { shendure } from 'src/services/http';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	import { save_home } from 'src/helpers/home_helpers';

	import { createEventDispatcher } from 'svelte';

	const dispatchFinishClick = createEventDispatcher<{ finish: {} }>();

	let user: string, pass: string;

	let loading = false;
	let error;

	onMount(() => {
		if ($home_data?.zendure) {
			user = $home_data.zendure.user;
		}
	});

	const zendureRegisterUser = async () => {
		loading = true;
		try {
			let res = await shendure.post('register_user', {
				username: user,
				password: pass,
			});

			if (res?.data?.isok) {
				save_home('zendure', {
					user: user,
					uid: res.data?.id,
				});

				dispatchFinishClick('finish');
			}
		} catch (err) {
			console.error('zendure register error:', err.response);
			if (!err.response?.data?.isok) {
				error = err.response?.data?.error || 'Error registering user';
			} else {
				error = 'Error processing request';
			}
		}
		loading = false;
	};

	const clearError = () => {
		if (typeof error !== 'undefined') error = undefined;
	};
</script>

{#if !$home_data?.zendure?.uid}
	<div class="d-flex flex-direction-column align-items-center">
		<Text element="h1" class="text-center mb-s" size="xl"
			>{$format('include_zendure_credentials', {
				default: 'Zendure Account Credentials',
			})}</Text
		>
		<Text class="text-center text-color-muted mb-l" styleType="body-small"
			>{$format('text_integrate_zendure_device', {
				default: 'PV consumption monitoring and device management.',
			})}</Text
		>

		<Input
			aria-labelledby="input-l2c243q"
			size="l"
			class="mb-m width-md-l width-sm-full"
			label="Username"
			bind:value={user}
			icon="fas fa-user"
			on:enter={() => {
				zendureRegisterUser();
			}}
			on:input={clearError}
			id="input-l2c243q"
		/>

		<Input
			a11yProps={{
				iconButtonAriaLabel: $format('input_set_password', { default: 'Input set password' }),
			}}
			aria-labelledby="input-frr8d9b"
			size="l"
			class="mb-m width-md-l width-sm-full"
			label={capFirstChar($format('label_password', { default: 'password' }))}
			bind:value={pass}
			type="password"
			icon="fas fa-lock-keyhole"
			{error}
			on:enter={() => {
				zendureRegisterUser();
			}}
			on:input={clearError}
			id="input-frr8d9b"
		/>

		<Button
			size="l"
			class="width-md-l width-sm-full"
			variant="primary"
			{loading}
			disabled={$home_data?.zendure?.user || loading || error}
			on:click={() => {
				zendureRegisterUser();
			}}
		>
			{capFirstChar(
				$format('button_associate', {
					default: 'Associate',
				}),
			)}
		</Button>
	</div>
{/if}
